var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "285px",
    height: "247px",
    viewBox: "0 0 285 247",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Oval Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--Book-pickup-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-pickup---small-screen---thank-you",
    transform: "translate(-40.000000, -67.000000)",
    fill: "#35334B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.5,314 C268.200577,314 324.078125,261.1696 324.078125,196 C324.078125,130.8304 273.700577,67 195,67 C116.299423,67 40.046875,115.8304 40.046875,181 C40.046875,246.1696 110.799423,314 189.5,314 Z",
    id: "Oval-Copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBg);
export default __webpack_public_path__ + "static/media/dark-bg.aedd54be4de5e2c7b25cc01df03cc484.svg";
export { ForwardRef as ReactComponent };